import { Box } from '@mui/material';
import { FC } from 'react';
import { matchHostname } from '@lendica/utils';

import { StatusPage } from '@lendica/components';

export const NoApproval: FC = () => {
    return (
        <Box
            sx={{
                px: 4,
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <StatusPage
                title="Application not approved"
                subtitle="Seems like you haven't completed your application"
                duration={10}
                action={() => window.location.replace(`https://apply.${matchHostname()}/login`)}
                actionLabel="Go to Application"
            />
        </Box>
    );
};
